var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg04WmdrUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333C12.5773 13.3333 14.6667 11.244 14.6667 8.66667C14.6667 6.08934 12.5773 4 10 4C7.42268 4 5.33334 6.08934 5.33334 8.66667C5.33334 11.244 7.42268 13.3333 10 13.3333Z",
    fill: "#396EF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22 13.3333C24.5773 13.3333 26.6667 11.244 26.6667 8.66667C26.6667 6.08934 24.5773 4 22 4C19.4227 4 17.3333 6.08934 17.3333 8.66667C17.3333 11.244 19.4227 13.3333 22 13.3333Z",
    fill: "#396EF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14 18.6667H24.6667C27.24 18.6667 29.3333 20.7601 29.3333 23.3334C29.3333 25.9067 27.24 28.0001 24.6667 28.0001H14V18.6667Z",
    fill: "#396EF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 23.3334C18.6667 25.9067 16.5733 28.0001 14 28.0001H7.33332C6.05332 28.0001 4.87999 27.4801 4.03999 26.6267C3.18666 25.7867 2.66666 24.6134 2.66666 23.3334C2.66666 20.7601 4.75999 18.6667 7.33332 18.6667H14C15.28 18.6667 16.4533 19.1867 17.2933 20.0401C18.1467 20.8801 18.6667 22.0534 18.6667 23.3334Z",
    fill: "#396EF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04WmdrUsers);
export default __webpack_public_path__ + "static/media/04_wmdr_users.a56def00d27041dd2bb10b21edf62272.svg";
export { ForwardRef as ReactComponent };